import createReactComponent from '../createReactComponent';
export default createReactComponent('music-minus', 'IconMusicMinus', [
  ['path', { d: 'M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0', key: 'svg-0' }],
  ['path', { d: 'M9 17v-13h10v11', key: 'svg-1' }],
  ['path', { d: 'M9 8h10', key: 'svg-2' }],
  ['path', { d: 'M16 19h6', key: 'svg-3' }],
]);
